const SERVICE_LABELS = {
  ST01: 'Complete service',
  ST02: 'Polishing service',
  ST03: 'Quick service',
  ST04: 'Restoration',
  ST05: 'Service outsourced to other affiliate',
  ST06: 'Service Declined by Rolex',
  STM01: 'Regular terms',
  STM02: 'Under sales guarantee domestic',
  STM03: 'Under sales guarantee abroad',
  STM04: 'Under service guarantee domestic',
  STM05: 'Under service guarantee abroad',
  STM06: 'Out of guarantee free of charge',
  STM07: 'New Goods (Affiliate stock)',
  STM08: 'New Goods (Authorised Retailer stock)',
  STM09: 'Administrative work',
  SD01: 'Quote declined by customer',
  SD02: 'Full acceptance',
  SD03: 'Partial acceptance',
  SD04: 'Not in original condition, modified',
  SD05: 'Old model, unrepairable, no spare parts',
  SD06: 'Partially or entirely counterfeit',
  SD07: 'For other reason',
};

export const getServiceString = (serviceCode, t) => {
  if (typeof serviceCode !== 'string' || !serviceCode.trim()) {
    return '';
  }

  const normalizedServiceCode = serviceCode.trim();
  const defaultValue = SERVICE_LABELS[normalizedServiceCode];

  if (!defaultValue) {
    return normalizedServiceCode;
  }

  return t(normalizedServiceCode, { defaultValue });
};
